/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
import Cookie from "js-cookie";
import Client from "../shared/services/Client";
import appConfig from "../utils/appConfig";
import { SUBSCRIPTIONS, SUBSCRIPTIONS_DATA_COOKIE_NAME } from "common/constants/Constants";
import { BULK_SUBSCRIPTION_USER_ROLES } from "common/constants/v2/Constants";

interface AddSubscriptionPayload {
    subscriptionInfo: string;
}

export default {
    getSubscriptions(
        { showAccounts = false, showRatePlans = false, activeOnly = true, bulkSubscriptionActive = true } = {}): Promise<any> {
        return Client.get(`/api/entitlements/subscriptions?showAccounts=${ showAccounts.toString() }`
        + `&showRatePlans=${ showRatePlans.toString() }&active=${ activeOnly.toString() }`
        + `&bulkSubscriptionActive=${ bulkSubscriptionActive.toString() }`)
            .catch((error) => {
                throw error;
            });
    },

    addBusinessweekSubscription(payload: AddSubscriptionPayload): Promise<any> {
        return Client.post("/api/entitlements/businessweek-subscription", payload);
    },

    addBloombergSubscription(payload: AddSubscriptionPayload): Promise<any> {
        return Client.post("/api/entitlements/subscription", payload);
    },

    updateSubscription(subscriptionId: string, productRatePlanId: string): Promise<any> {
        return Client.post("/api/entitlements/amendment", {
            subscriptionId,
            productRatePlanId
        });
    },

    getUserInvoices(): Promise<any> {
        return Client.get("/api/entitlements/invoices");
    },

    downloadInvoice(invoiceId: string): Promise<Response> {
        return fetch(`${ appConfig().registrationServiceUrl }/api/entitlements/download-invoice/${ invoiceId }`, { credentials: "include" });
    },

    updateSubscriptionPaymentMethod(paymentMethod: PaymentStructure, id: string): Promise<any> {
        return Client.post("/api/entitlements/update-subscription-payment-method", {
            paymentMethod,
            id
        });
    },

    hasLinkedSubscription(): boolean {
        const subscriptions = Cookie.get(SUBSCRIPTIONS) || "";

        return subscriptions.includes("bw-digital") || subscriptions.includes("bw-print");
    },

    updateUserRoleInBulkSubscription(
        subscriptionId: string, subscriberId: string, role: BULK_SUBSCRIPTION_USER_ROLES): Promise<any> {
        return Client.put(`/api/bulk-subscriptions/v3/${ subscriptionId }/update-user-role`, {
            subscriberId,
            role
        });
    },

    addBulkSubscriptionUser(bulkSubscriptionId: string, email: string): Promise<any> {
        return Client.post(`/api/bulk-subscriptions/v3/${ bulkSubscriptionId }/user`, {
            email
        });
    },

    removeBulkSubscriptionUser(bulkSubscriptionId: string, subscriberId: string): Promise<any> {
        return Client.delete(`/api/bulk-subscriptions/v3/${ bulkSubscriptionId }/users/${ subscriberId }`);
    },

    getBulkSubscriptionUsers(subscriptionId: string): Promise<any> {
        return Client.get(`/api/bulk-subscriptions/v3/${ subscriptionId }/get-users`);
    },

    getBulkSubscriptionAdmins(subscriptionId: string): Promise<any> {
        return Client.get(`/api/bulk-subscriptions/v3/${ subscriptionId }/get-admins`);
    },

    resendBulkSubscriptionVerificationEmail(subscriptionId: string, subscriberId: string): Promise<any> {
        return Client.put(`/api/bulk-subscriptions/v3/${ subscriptionId }/resend-verification-email`, {
            subscriberId
        });
    },

    hasActiveSubscriptions(): boolean {
        const subscriptions = Cookie.get(SUBSCRIPTIONS_DATA_COOKIE_NAME) || "";

        try {
            const subscriptionsData = JSON.parse(subscriptions) as SubscriptionCookieData[];
            
            return subscriptionsData.length > 0;
        } catch (e) {
            return false;
        }
    },

    getProductRatePlanInformation(productRatePlanId: string): Promise<any> {
        return Client.get(`/api/subscription/product-details?id=${ productRatePlanId }`)
            .then((response: {success?: any}) => {
                if (!response.success) {
                    // eslint-disable-next-line @typescript-eslint/no-throw-literal
                    throw response;
                }

                return response;
            });
    }
};
